import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (identifier, password, remember = false) => {
    const { data } = await api.post("/auth/login", { identifier, password, remember });
    setUser(data);
    return data;
  };
  const requestOtp = async (phone) => {
    const { data } = await api.post("/auth/otp/request", { phone });
    return data;
  };
  const loginWithOtp = async (phone, code, remember = false) => {
    const { data } = await api.post("/auth/otp/verify", { phone, code, remember });
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, requestOtp, loginWithOtp, register, logout, checkAuth }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
